/**
 * Helpers puros del alta de turnos: body de POST entradas-cola y validación del pedido
 */
import { PEDIDO_FORMATO } from "../constants";

const MENSAJE_PEDIDO_VACIO = "Introduce un número de pedido.";
const MENSAJE_PEDIDO_FORMATO = "Formato de pedido no válido. Ejemplo: 01-123";

/**
 * Arma el body de POST entradas-cola (snake_case, solo lo que lee EntradasDTO).
 * numero null/vacío = turno sin pedido. pedidos_cliente solo si se pide explícitamente.
 * No se envía estado: el backend fija 'esperando' e ignora el del body.
 */
export const construirEntradaTurno = ({ numero, idCola, ejercicio, pedidosCliente = false }) => {
    const recortado = typeof numero === "string" ? numero.trim() : numero;
    const entrada = {
        numero: recortado || null,
        id_cola: idCola,
        ejercicio,
    };
    if (pedidosCliente === true) entrada.pedidos_cliente = true;
    return entrada;
};

/**
 * Valida el pedido escrito por el usuario. Devuelve null si es válido o el
 * mensaje a mostrar. DECISION: el legacy no validaba el formato y un valor sin
 * guion llegaba al backend como pedido '123-undefined'.
 */
export const validarNumeroPedido = (valor) => {
    const texto = String(valor ?? "").trim();
    if (!texto) return MENSAJE_PEDIDO_VACIO;
    return PEDIDO_FORMATO.test(texto) ? null : MENSAJE_PEDIDO_FORMATO;
};
